import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layout/Layout";
import { Dashboard } from "./componants/admin/Dashboard";
import "bootstrap/dist/css/bootstrap.min.css";
import LoginPage from "./componants/auth/Login";
import RequireAuth from "./componants/auth/RequireAuth";
import RedirectIfLoggedIn from "./componants/auth/RedirectIfLoggedIn";
import AllBlogs from "./componants/blogsPage/AllBlogs";
import CreateBlogs from "./componants/blogsPage/CreateBlogs";
import UpdateBlogs from "./componants/blogsPage/UpdateBlogs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SingleBlog from "./componants/blogsPage/SingleBlog";
import { Contact } from "./componants/pages/Contact";
import Youtube from "./componants/pages/Youtube";

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="admin-login" replace />} />
          <Route element={<RedirectIfLoggedIn />}>
            <Route path="admin-login" element={<LoginPage />} />
          </Route>
          {/* Protected Routes */}
          {/* <Route element={<RequireAuth />}> */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="contact" element={<Contact />} />
          <Route path="youtube" element={<Youtube />} />
          <Route path="blogs" element={<AllBlogs />} />
          <Route path="create-blog" element={<CreateBlogs />} />
          <Route path="update/blog/:slug" element={<UpdateBlogs />} />
          <Route path="blogs/:slug" element={<SingleBlog />} />
        </Route>
        {/* </Route> */}
      </Routes>
    </>
  );
}

export default App;
